<template>
  <div>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <div class="card-body text-center">
      <div class="card-title text-center">
        <h3>Delivery</h3>
      </div>
      <form @submit.prevent>
        <div class="form-group text-left">
          <label for="deliveryProduct">Product</label>
          <base-input class="mb-3"
                      id="deliveryProduct"
                      required='required'
                      placeholder=""
                      name='deliveryProduct'
                      v-model="deliveryInfo.deliveryProduct"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      data-vv-as="Product"
                      :error="vErrors.first('deliveryProduct')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="boxesNumber">Number of Boxes</label>
          <base-input class="mb-3"
                      id="boxesNumber"
                      required='required'
                      placeholder=""
                      name='boxesNumber'
                      v-model="deliveryInfo.boxesNumber"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      data-vv-as="Number of Boxes"
                      :error="vErrors.first('boxesNumber')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="printedName">Printed name</label>
          <base-input class="mb-3"
                      id="printedName"
                      required='required'
                      placeholder=""
                      name='printedName'
                      v-model="deliveryInfo.printedName"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      data-vv-as="Printed name"
                      :error="vErrors.first('printedName')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="">Before picture</label>
          <div>
            <a v-on:click='takeSignature' class="link"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Tap to capture one or more signature</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i>{{deliveryInfo.signatures.length}}</badge>
          </div>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="deliveryInfo.pickup">
              Pickup
          </base-checkbox>
        </div>
        <div class="text-center">
            <base-button :disabled="disableSubmitButton" v-if="showSubmitButton() && !isJobActionCopleted(4)" type="primary" @click="deliveryInfoSend" size='md' class="my-4">Submit</base-button>
        </div>
      </form>
    </div>
  </div>

</template>
<script>
import jobActionFormMixin from './../views/mixins/jobActionFormMixin'
import jobActionsMixin from './../views/mixins/jobActionsMixin'
import standsMixin from './../views/mixins/standsMixin'
import jobsMixin from './../views/mixins/jobsMixin'
import camera from './Camera'
import signatures from './Signatures'
export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null,
      deliveryInfo: {
        deliveryProduct: null,
        boxesNumber: null,
        printedName: null,
        signatures: [],
        pickup: null
      }
    }
  },
  props: {
    disableSubmitButton: {
      type: Boolean,
      default: false,
      description: 'Disable submit button'
    }
  },
  methods: {
    deliveryInfoSend () {
      this.$validator.validateAll({
        deliveryProduct: this.deliveryInfo.deliveryProduct,
        boxesNumber: this.deliveryInfo.boxesNumber,
        printedName: this.deliveryInfo.printedName
      }).then(response => {
        if (response) {
          this.$emit('deliveryInfoFormDataSend', this.deliveryInfo)
        }
      })
    }
  },
  mixins: [jobActionFormMixin, jobActionsMixin, jobsMixin, standsMixin],
  components: {
    camera,
    signatures
  }
}
</script>
<style>
</style>
